import { render, staticRenderFns } from "./ConfigParameterList.vue?vue&type=template&id=63a3477c&scoped=true&"
import script from "./ConfigParameterList.vue?vue&type=script&lang=js&"
export * from "./ConfigParameterList.vue?vue&type=script&lang=js&"
import style0 from "./ConfigParameterList.vue?vue&type=style&index=0&id=63a3477c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a3477c",
  null
  
)

export default component.exports